import {useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withParams} from "../../App";
import PageComponent from "../pageComponent/pageComponent";
import {useLlmDataStore} from "../../store/llmDataStore";
import {getTopicPages} from "./pageDataHelpers";

// Rendered when the current slug isn't found in the data (or while data
// hasn't loaded yet) so the page still has something sensible to show
// instead of throwing on undefined fields.
const DEFAULT_ENTRY = {
    title: 'Large Language Models',
    tags: [], sourceLinks: [], languages: [], algos: [], attributed: [],
    source: '', dataFile: '', download: ''
};

const DEFAULT_NEXT = {key: '', slug: '', title: 'Large Language Models', path: '/llm'};

// Routed from four separate paths in App.js (one per landing-page section —
// /llm/basics/, /llm/models/, /llm/running-locally/, /llm/fine-tuning/), all
// rendering this same component. Reads the slug via useParams() directly
// (rather than a `params` prop) so it works regardless of which of those
// routes matched — see ptComponent.js, which this was originally copied from
// and has the same constraint.
export const LLMPage = () => {
    const {slug = ''} = useParams();

    // useLlmDataStore fetches /data/llmData.json once (cached in memory +
    // localStorage) — see src/store/createDataStore.js.
    const {slugs, nextPage, relatedPages, suggestedCourses, isLoaded, loadData} = useLlmDataStore();

    useEffect(() => {
        loadData();
    }, [loadData]);

    if (!isLoaded) {
        return <div>Loading…</div>;
    }

    const found = slugs.find(item => item.slug === slug);
    if (!found) {
        console.error('LLMPage Failed to locate HTML path for slug : ' + slug);
    }
    const current = found || DEFAULT_ENTRY;

    const next = nextPage.find(item => item.key === slug);
    const related = relatedPages.filter(item => item.key === slug);
    const suggested = suggestedCourses.filter(item => item.key === slug);
    const topicPages = getTopicPages(slugs, current, slug);

    const state = {
        nextContent: next || DEFAULT_NEXT,
        relatedContent: related,
        topicPages,
        title: current.title,
        tags: current.tags,
        sourceLinks: current.sourceLinks,
        languages: current.languages,
        algos: current.algos ?? [],
        suggestedCourses: suggested,
        attributed: current.attributed,
        source: current.source,
        html: '',
        dataFile: current.dataFile,
        download: current.download
    };

    return (
        <PageComponent props={state} page="LLM Page"/>
    );
};

export default withParams(LLMPage);
